import { Navigate, useLocation } from "react-router-dom";
import useAuth, { isValidUserSession } from "../hooks/useAuth";

interface ProtectedRouteProps {
  userRoles?: string[];
  children: JSX.Element;
}

const ProtectRoute: React.FC<ProtectedRouteProps> = ({
  userRoles,
  children,
}) => {
  const { user, roles } = useAuth();
  const location = useLocation();

  const hasRequiredRole = userRoles?.some((role) =>
    roles.some((userRole) => userRole.RoleName === role)
  );

  if (!isValidUserSession(user)) {
    return <Navigate to={"/"} state={{ from: location }} replace />;
  }

  if (userRoles && !hasRequiredRole) {
    return null;
  }

  return children;
};

export default ProtectRoute;
